import { useMutation, useQuery } from "@apollo/client";
import {
  CREATE_USER,
  GET_USER,
  GET_USER_STATS,
  GET_ALL_USERS,
  UPDATE_USER,
} from "@store/operations/userOperations";

export const useCreateUser = () =>
  useMutation(CREATE_USER, {
    update: (cache, { data: { createUser } }) => {
      const data = cache.readQuery({
        query: GET_ALL_USERS,
      });
      cache.writeQuery({
        query: GET_ALL_USERS,
        data: {
          users: [...(data.users || []), createUser],
        },
      });
    },
  });

export const useUpdateUser = () => useMutation(UPDATE_USER);

export const useGetAllUser = () => useQuery(GET_ALL_USERS);

export const useGetUser = (options) => useQuery(GET_USER, { fetchPolicy:"network-only", ...options });
export const useUserStats = (options) => useQuery(GET_USER_STATS, { fetchPolicy:"no-cache", ...options });
